<template>
    <div>
        <div class="me-header"></div>
<!--        <div class="text-center" style="margin-top:-30px;">-->
<!--            <img src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201609%2F01%2F20160901172942_XHjEs.thumb.700_0.jpeg&refer=http%3A%2F%2Fb-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1616909119&t=4eefda0107069b7760df20cb336eafb2" class="avatar"/>-->
<!--        </div>-->
        <van-form @submit="onSubmit" class="margin-top-70">
            <van-field
                v-model="formData.mobile"
                placeholder="请输入招标网登录手机号"
                left-icon="contact"
                type="tel"
                :rules="[{ required: true, message: '请填写用户名' }]"
            />
            <van-field
                v-model="formData.password"
                type="password"
                placeholder="请输入密码"
                left-icon="bag-o"
                :rules="[{ required: true, message: '请填写密码' }]"
            />
            <div style="margin:50px 50px 0 50px;">
                <van-button round block color="#144b9e" native-type="submit">登录</van-button>
                <van-button round block type="info" class="margin-top-20" @click="$router.push({path:'/register',query:{...$route.query}})">注册</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
export default {
    name: "login",
    data() {
        return {
            formData:{
                mobile: '',
                password: '',
                dingyue_openid:'',
                fuwu_openid:'',
                key:''
            }
        };
    },
    created() {
        this.$emit('bgColor','#fff');
        this.formData.dingyue_openid = this.$route.query.dingyue_openid ? this.$route.query.dingyue_openid : '';
        this.formData.fuwu_openid = this.$route.query.fuwu_openid ? this.$route.query.fuwu_openid : '';
        this.formData.key = this.$route.query.key ? this.$route.query.key : '';
    },
    methods:{
        onSubmit(values) {
            let _this = this;

            this.$http.post({
                url:'User/login',
                data:this.formData,
                success(res){
                    _this.$notify({ type: 'success', message: '登录成功' });

                    _this.$user.setToken(res.token);
                    _this.$user.setUid(res.uid);
                    _this.$user.setMobile(res.mobile);
                    _this.$user.setUserName(res.username);
                    _this.$user.setDingyueOpenid(res.dingyue_openid);
                    _this.$user.setFuwuOpenid(res.fuwu_openid);
                    _this.$user.setAvatar(res.avatar);

                    let _lastPath = _this.$store.state.lastPath;

                    if(_lastPath){
                        _this.$router.replace({path:_lastPath,query:{..._this.$route.query}});
                    }else {
                        _this.$router.replace({path: '/',query:{..._this.$route.query}});
                    }
                }
            })
        },
    }
}
</script>
